
import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'

import Modal from '../../../shared/modal/Modal'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import api from '../../../utils/api'

import EditColorType from '../EditColorType'

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'


function ListColorTypeRow({ dataArray, myPermissionView, myPermissionEdit, myPermissionDelete, handleOnSuccess }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    /* ------------------- Modal useState ----------------------*/

    const [modalEditColorType, setModalEditColorType] = useState(false)
    const [colorTypeId, setColorTypeId] = useState("")
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [colorTypeName, setColorTypeName] = useState("")

    async function deleteColorType(id) {
        let msgType = 'success'
        const data = await api.delete(`/colorType/delete/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                handleOnSuccess()
                setModalDeleteItem(false)
            }

            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)
    }

    /* ------------------------ cards ------------------------------ */
    const listArray = () => {
        if (myPermissionView && dataArray && dataArray.length > 0) {
            return dataArray.map((item) => (
                <div key={item._id} className='pg-item'>
                    <div className='pg-item-main'>
                        <span className='pg-item-name'>{item.name}</span>
                    </div>

                    <div className='shd-row-box-item-action'>
                        {myPermissionEdit &&
                            <FaPencilAlt className='shd-icon-row-edit' title='Editar' onClick={() => { setColorTypeId(item._id); setModalEditColorType(true) }} />
                        }
                        {myPermissionDelete &&
                            <FaTrashAlt className='shd-icon-row-trash' title='Apagar' onClick={() => { setModalDeleteItem(true); setColorTypeId(item._id); setColorTypeName(item.name) }} />
                        }
                    </div>
                </div>
            ))
        }
    }

    return (
        <div>
            {listArray()}

            <Modal
                modalStatus={modalEditColorType}
                changeStatus={setModalEditColorType}
                w={82}
                content={
                    <EditColorType id={colorTypeId} handleOnSuccess={() => { setModalEditColorType(false); handleOnSuccess() }} btCancelAction={() => setModalEditColorType(false)} />
                }
            />

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteColorType(colorTypeId)}
                message="Deseja realmente excluir esse tipo de cor?"
                itemName={colorTypeName}
            />

        </div>
    )
}

export default ListColorTypeRow
